module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_smaller-64b9f882838029a294871273a9aff9ff.svg";